/* ============================================================
   AURA FRAGRANCES — theme behaviour
   Cart drawer (AJAX), slideshow, mobile nav, accordions,
   quantity pickers, variant picker, product recommendations
   ============================================================ */
(function () {
  'use strict';

  var moneyFormat = document.body.getAttribute('data-money-format') || '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = parts.join('.');
    if (moneyFormat.indexOf('{{amount}}') !== -1) return moneyFormat.replace('{{amount}}', formatted);
    if (moneyFormat.indexOf('{{amount_no_decimals}}') !== -1) return moneyFormat.replace('{{amount_no_decimals}}', parts[0]);
    return formatted;
  }

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('.site-header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('site-header--scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Search toggle ---------- */
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bar = document.getElementById('HeaderSearch');
      if (!bar) return;
      bar.classList.toggle('header__search--open');
      var input = bar.querySelector('input');
      if (input && bar.classList.contains('header__search--open')) input.focus();
    });
  });

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.getElementById('MobileNav');
  document.querySelectorAll('[data-mobile-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileNav) { mobileNav.classList.add('mobile-nav--open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-mobile-close]').forEach(function (el) {
    el.addEventListener('click', closeMobileNav);
  });
  function closeMobileNav() {
    if (mobileNav) { mobileNav.classList.remove('mobile-nav--open'); document.body.style.overflow = ''; }
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var drawerItems = document.getElementById('CartDrawerItems');
  var drawerFoot = document.getElementById('CartDrawerFoot');
  var drawerCount = document.getElementById('CartDrawerCount');
  var drawerShip = document.getElementById('CartDrawerShip');
  var shipThreshold = parseFloat((document.querySelector('[data-ship-threshold]') || {}).dataset?.shipThreshold || '150') * 100;
  var showShipBar = drawerShip && drawerShip.dataset.showBar === 'true';

  function openDrawer() {
    if (!drawer) return;
    refreshDrawer();
    drawer.classList.add('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMobileNav(); }
  });

  function cartItemHTML(item) {
    var opts = (item.options_with_values || []).map(function (o) { return o.value; }).join(' / ');
    return '' +
      '<div class="cart-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '"><img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></a>' +
        '<div>' +
          '<p class="cart-item__title"><a href="' + item.url + '">' + item.product_title + '</a></p>' +
          (opts ? '<p class="cart-item__variant">' + opts + '</p>' : '') +
          '<div class="cart-item__qty">' +
            '<button type="button" data-qty-dec aria-label="Decrease quantity">&minus;</button>' +
            '<input type="text" value="' + item.quantity + '" readonly aria-label="Quantity">' +
            '<button type="button" data-qty-inc aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item__right">' +
          '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
          '<button type="button" class="cart-item__remove" data-remove>Remove</button>' +
        '</div>' +
      '</div>';
  }

  function refreshDrawer() {
    if (!drawerItems) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBubbles(cart.item_count);
        if (drawerCount) drawerCount.textContent = cart.item_count;

        if (!cart.items.length) {
          drawerItems.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><p>Discover a scent that feels like you.</p><a href="/collections/all" class="btn btn--outline btn--small" data-cart-close>Shop Bestsellers</a></div>';
          if (drawerFoot) drawerFoot.innerHTML = '';
          if (drawerShip) drawerShip.innerHTML = '';
          bindDrawerLinks();
          return;
        }

        drawerItems.innerHTML = cart.items.map(cartItemHTML).join('');

        if (showShipBar && drawerShip) {
          var remaining = shipThreshold - cart.total_price;
          var pct = Math.min(100, Math.round((cart.total_price / shipThreshold) * 100));
          drawerShip.innerHTML = remaining > 0
            ? '<span>You are <strong>' + formatMoney(remaining) + '</strong> away from complimentary shipping.</span><div class="cart-drawer__shipbar"><i style="width:' + pct + '%"></i></div>'
            : '<span>Your order ships <strong>complimentary</strong>, wrapped in gold.</span><div class="cart-drawer__shipbar"><i style="width:100%"></i></div>';
        } else if (drawerShip) {
          drawerShip.innerHTML = '';
        }

        if (drawerFoot) {
          drawerFoot.innerHTML =
            '<div class="cart-drawer__subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
            '<p class="cart-drawer__note">Shipping and taxes calculated at checkout.</p>' +
            '<a href="/checkout" class="btn btn--full">Checkout</a>' +
            '<a href="/cart" class="btn btn--outline btn--full">View Cart</a>';
        }
        bindDrawerControls();
      })
      .catch(function () {
        drawerItems.innerHTML = '<div class="cart-drawer__empty"><p>Something went wrong loading your cart.</p></div>';
      });
  }

  function bindDrawerLinks() {
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
  }

  function bindDrawerControls() {
    drawerItems.querySelectorAll('.cart-item').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var dec = row.querySelector('[data-qty-dec]');
      var inc = row.querySelector('[data-qty-inc]');
      var input = row.querySelector('input');
      var qty = parseInt(input.value, 10) || 1;
      if (dec) dec.addEventListener('click', function () { changeQty(key, Math.max(0, qty - 1)); });
      if (inc) inc.addEventListener('click', function () { changeQty(key, qty + 1); });
      var rm = row.querySelector('[data-remove]');
      if (rm) rm.addEventListener('click', function () { changeQty(key, 0); });
    });
  }

  function changeQty(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshDrawer).catch(refreshDrawer);
  }

  function updateCartBubbles(count) {
    document.querySelectorAll('.cart-count').forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ---------- Add to cart (all forms) ---------- */
  document.querySelectorAll('form[data-add-to-cart], form[data-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { openDrawer(); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  });

  /* ---------- Slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dot');
    var count = hero.querySelector('.hero__count');
    var current = 0, timer = null;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(hero.getAttribute('data-speed') || '6000', 10);

    function goTo(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('hero__slide--active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('hero__dot--active', idx === current); });
      if (count) count.textContent = (current + 1) + ' / ' + slides.length;
      restart();
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (autoplay && slides.length > 1) timer = setInterval(function () { goTo(current + 1); }, speed);
    }
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { goTo(idx); }); });
    var prev = hero.querySelector('[data-slide-prev]');
    var next = hero.querySelector('[data-slide-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    hero.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    hero.addEventListener('mouseleave', restart);
    goTo(0);
  });

  /* ---------- Accordions ---------- */
  document.querySelectorAll('.accordion__head').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.closest('.accordion__item');
      var body = item.querySelector('.accordion__body');
      var open = item.classList.toggle('accordion__item--open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
    });
  });
  // Open first accordion by default on product pages
  var firstAcc = document.querySelector('.product .accordion__item');
  if (firstAcc) {
    firstAcc.classList.add('accordion__item--open');
    var fb = firstAcc.querySelector('.accordion__body');
    if (fb) fb.style.maxHeight = fb.scrollHeight + 'px';
  }

  /* ---------- Quantity pickers (product forms) ---------- */
  document.querySelectorAll('[data-qty-picker]').forEach(function (picker) {
    var input = picker.querySelector('input');
    picker.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        if (btn.hasAttribute('data-qty-minus')) val = Math.max(1, val - 1);
        if (btn.hasAttribute('data-qty-plus')) val = Math.min(99, val + 1);
        input.value = val;
      });
    });
  });

  /* ---------- Variant picker (product page) ---------- */
  var variantData = document.getElementById('VariantData');
  if (variantData) {
    try {
      var variants = JSON.parse(variantData.textContent);
      var form = document.querySelector('[data-product-form]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEl = document.querySelector('[data-product-price]');
      var mainImg = document.querySelector('[data-main-image]');
      var optionGroups = document.querySelectorAll('[data-option-group]');

      function currentSelections() {
        var sel = [];
        optionGroups.forEach(function (g) {
          var active = g.querySelector('.variant-swatch--active');
          sel.push(active ? active.getAttribute('data-value') : null);
        });
        return sel;
      }
      function findVariant() {
        var sel = currentSelections();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === sel[i]; });
        });
      }
      function refreshVariant() {
        var v = findVariant();
        if (!v || !idInput) return;
        idInput.value = v.id;
        var addBtn = form.querySelector('[type="submit"]');
        if (priceEl) {
          priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '') + formatMoney(v.price);
        }
        if (!v.available && addBtn) { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
        else if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
        if (v.featured_image && mainImg) {
          mainImg.src = v.featured_image.src;
          mainImg.alt = v.featured_image.alt || '';
          document.querySelectorAll('.product__thumb').forEach(function (t) {
            t.classList.toggle('product__thumb--active', t.getAttribute('data-src') === v.featured_image.src);
          });
        }
        optionGroups.forEach(function (g, gi) {
          var label = g.querySelector('[data-option-value]');
          if (label && v.options[gi]) label.textContent = v.options[gi];
        });
      }
      optionGroups.forEach(function (g) {
        g.querySelectorAll('.variant-swatch').forEach(function (sw) {
          if (sw.classList.contains('variant-swatch--soldout')) return;
          sw.addEventListener('click', function () {
            g.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('variant-swatch--active'); });
            sw.classList.add('variant-swatch--active');
            refreshVariant();
          });
        });
      });
      refreshVariant();
    } catch (err) { /* variant data unreadable; leave defaults */ }
  }

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('.product__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('[data-main-image]');
      var src = thumb.getAttribute('data-src');
      if (mainImg && src) { mainImg.src = src; }
      document.querySelectorAll('.product__thumb').forEach(function (t) { t.classList.remove('product__thumb--active'); });
      thumb.classList.add('product__thumb--active');
    });
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('product-recommendations').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('product-recommendations');
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
          // Rebind quick-add forms injected via AJAX
          el.querySelectorAll('form[data-quick-add]').forEach(function (form) {
            form.addEventListener('submit', function (e) {
              e.preventDefault();
              fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
                .then(function () { openDrawer(); })
                .catch(function () { form.submit(); });
            });
          });
        } else {
          el.style.display = 'none';
        }
      })
      .catch(function () { el.style.display = 'none'; });
  });

  /* ---------- Sort by (collection) ---------- */
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
